import { jwtDecode } from 'jwt-decode';

export function isJwtExpired(jwtToken) {
  return jwtToken ? jwtDecode(jwtToken).exp < Date.now() / 1000 : false;
}
